/* ============================================================
   TRADIE — Colour swatch hover tooltip: escape carousel clipping
   Pairs with colour-swatch-tooltip.css.

   See that file for the full root cause. This computes the
   tooltip's on-screen position from the actual hovered swatch's
   bounding box, since position:fixed needs real viewport
   coordinates rather than the local top:-4px/left:50% the vendor
   CSS used when the tooltip was position:absolute inside the
   swatch.

   Uses delegated mouseover/mouseout (not mouseenter/mouseleave —
   those don't bubble at all, even in capture phase, so they can't
   be delegated from document) with the standard relatedTarget
   check to only reposition when genuinely entering a new swatch,
   not moving between child elements inside the same one. Delegation
   also means this doesn't need a MutationObserver to survive colour
   switches re-rendering the swatch row — the listener lives on
   document, not on the swatches themselves.

   Horizontal position is clamped to a small margin from the
   viewport edges so the tooltip doesn't run off-screen for the
   first/last swatch in the row — an approximation based on the
   swatch's center point, not the tooltip's own (variable, text-
   dependent) width, so it won't be pixel-perfect for very long
   colour names right at a screen edge, but avoids the common case.

   KNOWN TRADE-OFF: on scroll, every open tooltip is immediately
   hidden (suppressed) rather than continuously repositioned, so it
   can't visually drift away from the swatch it describes while the
   row is being dragged/scrolled. It clears again on the next fresh
   hover. If the mouse stays still on the same swatch through a
   scroll (e.g. scrolling via a separate arrow click), the tooltip
   stays hidden until the mouse actually moves off and back onto a
   swatch — a minor quirk, not a broken state.
   ============================================================ */

(function () {
  var SWATCH_SELECTOR = '.pf-color-swatch';
  var TOOLTIP_SELECTOR = '.pf-color-tooltip';
  var VERTICAL_GAP = 4; // matches the vendor's own `top: -4px` offset
  var EDGE_MARGIN = 20; // keep the tooltip this far from the screen edge

  function positionTooltip(swatch) {
    var tooltip = swatch.querySelector(TOOLTIP_SELECTOR);
    if (!tooltip) return;

    var rect = swatch.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var minX = EDGE_MARGIN;
    var maxX = window.innerWidth - EDGE_MARGIN;
    var clampedX = Math.min(Math.max(centerX, minX), maxX);

    tooltip.style.left = clampedX + 'px';
    tooltip.style.top = (rect.top - VERTICAL_GAP) + 'px';
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest ? e.target.closest(SWATCH_SELECTOR) : null;
    if (!swatch) return;
    if (swatch.contains(e.relatedTarget)) return; // still inside the same swatch

    swatch.classList.remove('pf-tooltip-suppress');
    positionTooltip(swatch);
  });

  function suppressAllTooltips() {
    document.querySelectorAll(SWATCH_SELECTOR).forEach(function (swatch) {
      swatch.classList.add('pf-tooltip-suppress');
    });
  }

  // Capture phase: 'scroll' doesn't bubble, so this is the only way
  // to catch it from a nested scrollable element (the swatch
  // carousel) as well as the page itself via one shared listener.
  document.addEventListener('scroll', suppressAllTooltips, true);
})();
